import { themeColors } from "../../config";
import Button from "../Button";
import styles from "../../styles";
import ModalStyles from "./style.js";
const Modal = ({
  width = 300,
  height = 200,
  leftText,
  leftFunc,
  rightText,
  rightFunc,
  children,
}) => {
  return (
    <div
      style={{
        ...styles.fullScreenContainer,
        backgroundColor: themeColors.transparentBlack,
      }}
    >
      <div
        style={{
          ...ModalStyles.container,
          width,
          height,
          backgroundColor: themeColors.transparentWhite,
        }}
      >
        <div style={ModalStyles.textContainer}>{children}</div>
        <div style={{ display: "flex" }}>
          <Button style={ModalStyles.leftButton} onClick={leftFunc}>
            {leftText}
          </Button>
          <Button style={ModalStyles.rightButton} onClick={rightFunc}>
            {rightText}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default Modal;
